import { getFormCreatorStore, ModifyForm } from '@/store/formCreator/actions';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormSettingsEnum } from '@dev/ee-api/ee-api-models';
import { remove } from 'lodash';
import { isSetNotifyEmails } from '../tools/isSetNotifyEmails';
import { useStep4Errors } from './useStep4Errors';

export const useEmailNotification = () => {
    const { formObject, formPayload } = useSelector(getFormCreatorStore);
    const dispatch = useDispatch();
    const [notify, setNotify] = useState(isSetNotifyEmails(formObject?.FormSettings));
    const { resetErrors } = useStep4Errors();
    const onNotifyChange = (e) => {
        const notifyEmails = e.target.checked;
        setNotify(notifyEmails);
        resetErrors();
        const formSettings = formPayload?.FormSettings ?? formObject?.FormSettings ?? [];
        const isNotifyEmailsInSettings = isSetNotifyEmails(formSettings);
        const isFormSettingsUpToDate = notifyEmails === isNotifyEmailsInSettings;

        if (isFormSettingsUpToDate) {
            return;
        }

        const newFormSettings = notifyEmails
            ? [...formSettings, FormSettingsEnum.NotifyEmails]
            : remove([...formSettings], (setting) => setting !== FormSettingsEnum.NotifyEmails);

        dispatch(
            ModifyForm({
                FormSettings: newFormSettings,
                EmailsToNotifyOnAction: '',
            })
        );
    };

    return { notify, onNotifyChange };
};
